import { createSignal, onMount, onCleanup } from "solid-js";
import { getVersion } from "../api/version";

const POLL_INTERVAL = 5 * 60 * 1000; // 5 minutes

export interface UseVersionCheckResult {
  updateAvailable: () => boolean;
  currentVersion: () => string;
  latestVersion: () => string | null;
}

export function useVersionCheck(
  intervalMs: number = POLL_INTERVAL,
): UseVersionCheckResult {
  const [updateAvailable, setUpdateAvailable] = createSignal(false);
  const [latestVersion, setLatestVersion] = createSignal<string | null>(null);

  const currentVersion = () => __APP_VERSION__;

  const check = async () => {
    try {
      const resp = await getVersion();
      setLatestVersion(resp.version);
      if (resp.version !== currentVersion()) {
        setUpdateAvailable(true);
      }
    } catch {
      // Silently ignore — network errors or 5xx just retry next interval
    }
  };

  let timer: ReturnType<typeof setInterval>;

  onMount(() => {
    check();
    timer = setInterval(check, intervalMs);
  });

  onCleanup(() => clearInterval(timer));

  return { updateAvailable, currentVersion, latestVersion };
}
